import { combineReducers, type Reducer } from 'redux';

import { instanceReducer } from './instance/reducer';
import { machineAccountsReducer } from './machineAccounts/reducer';
import { productMembersReducer } from './productMembers/reducer';
import { productsReducer } from './products/reducer';
import { productTypeMembersReducer } from './productTypeMembers/reducer';
import { productTypesReducer } from './productTypes/reducer';
import { rolesReducer } from './roles/reducer';
import { usersReducer } from './users/reducer';

export interface SafeScarfState {
  instance?: ReturnType<typeof instanceReducer> | undefined;
  users: ReturnType<typeof usersReducer>;
  machineAccounts: ReturnType<typeof machineAccountsReducer>;
  roles: ReturnType<typeof rolesReducer>;
  productTypes: ReturnType<typeof productTypesReducer>;
  productTypeMembers: ReturnType<typeof productTypeMembersReducer>;
  products: ReturnType<typeof productsReducer>;
  productMembers: ReturnType<typeof productMembersReducer>;
  userProfile?: unknown;
}

export const safescarfReducers = combineReducers({
  instance: instanceReducer,
  users: usersReducer,
  machineAccounts: machineAccountsReducer,
  roles: rolesReducer,
  productTypes: productTypesReducer,
  productTypeMembers: productTypeMembersReducer,
  products: productsReducer,
  productMembers: productMembersReducer,
}) as unknown as Reducer<SafeScarfState>;
